import {initializeApp} from 'firebase/app'
import {getFirestore, Timestamp} from 'firebase/firestore'
import {getAuth} from 'firebase/auth'
import {getStorage} from 'firebase/storage'
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCi2u5y-Mv7OnZdnGWot1NgQowopHaT0jI",
  // Same site as www.numetrics.org, so the SSO redirect's storage isn't
  // third-party; Hosting serves /__/auth/handler there.
  authDomain: "frameworks.numetrics.org",
  projectId: "numetrics-cte",
  storageBucket: "numetrics-cte.appspot.com",
  messagingSenderId: "280034522476",
  appId: "1:280034522476:web:aab04aa74043fa3778ef49",
  measurementId: "G-2QHZQMZTRC"
};
//init firebase
  initializeApp(firebaseConfig)


  const db = getFirestore()
  const timestamp = Timestamp
  const projectAuth = getAuth()
  const projectStorage = getStorage()

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  export { db, projectAuth, projectStorage, timestamp, analytics }